// extracted by mini-css-extract-plugin
export default {"datePickerContainer":"BCustomDatePicker-module_datePickerContainer_cc87fa07","datePicker":"BCustomDatePicker-module_datePicker_d222783f"};